module.exports = __webpack_public_path__ + "img/038.24531c0d.jpg";